// Frames cross the iOS message channel (and old Android WebViews) as base64 text, and HTTP
// request bodies travel as base64 inside the JSON of an open request.

// Not part of the ES2023 lib, but present in every runtime the bridge client runs in.
declare const btoa: (data: string) => string;
declare const atob: (data: string) => string;

const CHUNK = 0x8000; // keeps String.fromCharCode's argument list small

export function bytesToBase64(bytes: Uint8Array) : string {
    let binary = '';
    for (let offset = 0; offset < bytes.length; offset += CHUNK) {
        binary += String.fromCharCode(...bytes.subarray(offset, offset + CHUNK));
    }
    return btoa(binary);
}

export function base64ToBytes(text: string) : Uint8Array {
    const binary = atob(text);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
}
